
/*
 * This function is used to gather all of the slider-elements
 * and return them into an object.
 */
export const _elements = ( slider ) => {
	if ( slider ) {
		const sliderId = slider.getAttribute( 'data-slider' ) ? slider.getAttribute( 'data-slider' ) : null;
		const list = slider.querySelector( '[data-slider-list]' );
		const items = list.querySelectorAll( '[data-slider-item]' );
		const current = parseInt( slider.getAttribute( 'data-slider-current' ) );
		const navigator = sliderId ? document.querySelector( `[data-navigator="${ sliderId }"]` ) : null;

		return {
			slider,
			list,
			items,
			current,
			navigator,
		};
	}

	return false;
};
